import { render, staticRenderFns } from "./PatentUpdateFieldsForm.vue?vue&type=template&id=7ebdf4ce&"
import script from "./PatentUpdateFieldsForm.vue?vue&type=script&lang=js&"
export * from "./PatentUpdateFieldsForm.vue?vue&type=script&lang=js&"
import style0 from "./PatentUpdateFieldsForm.vue?vue&type=style&index=0&id=7ebdf4ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports